import type { IconGlyph } from '@ipfabric/ui-components/Icon/IconGlyph';
import { DiscoveryConfigWizardPage1 } from 'app/features/DiscoverySettingsForms/composition/DiscoveryConfigWizard/DiscoveryConfigWizardPage1';
import { DiscoveryConfigWizardPage2 } from 'app/features/DiscoverySettingsForms/composition/DiscoveryConfigWizard/DiscoveryConfigWizardPage2';
import { DiscoveryConfigWizardPage3 } from 'app/features/DiscoverySettingsForms/composition/DiscoveryConfigWizard/DiscoveryConfigWizardPage3';
import { DiscoveryConfigWizardPage4 } from 'app/features/DiscoverySettingsForms/composition/DiscoveryConfigWizard/DiscoveryConfigWizardPage4';
import type { WizardPageProps } from 'app/features/DiscoverySettingsForms/composition/DiscoveryConfigWizard/configWizard.types';
import type { ComponentType } from 'react';

interface WizardStepConfig {
  icon: IconGlyph;
  tooltip: string;
  path: string;
  Component: ComponentType<WizardPageProps>;
  submitOnPrevious?: boolean;
  isFinalStep?: boolean;
}

const PATH_WIZARD_BASE = '/wizard';

export const wizardStepsConfig = [
  {
    icon: 'fa-circle-1' as const,
    tooltip: 'Device Credentials',
    path: `${PATH_WIZARD_BASE}/1`,
    Component: DiscoveryConfigWizardPage1,
  },
  {
    icon: 'fa-circle-2' as const,
    tooltip: 'Discovery Seeds / IP Scope',
    path: `${PATH_WIZARD_BASE}/2`,
    Component: DiscoveryConfigWizardPage2,
  },
  {
    icon: 'fa-circle-3' as const,
    tooltip: 'Advanced CLI',
    path: `${PATH_WIZARD_BASE}/3`,
    Component: DiscoveryConfigWizardPage3,
  },
  {
    icon: 'fa-circle-4' as const,
    tooltip: 'Run Discovery',
    path: `${PATH_WIZARD_BASE}/4`,
    Component: DiscoveryConfigWizardPage4,
  },
] as const satisfies readonly WizardStepConfig[];

export const DISCOVERY_WIZARD_FINAL_STEP_PATH = wizardStepsConfig[3].path;
